import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from 'react';
import { connect } from 'react-redux';
import moment from 'moment';
import { addError } from 'actions';
import { getUserCourses } from 'actions/user';
import { clearVerdicts, getAssignmentAssessments, getPlanAssessments, getStudentLatestVerdict, getUserStudyPlan, resetPlanAssessments, resetAssignmentAssessments, getVerdictsForUser, getStudentVerdicts, getVerdictScale } from 'actions/verdicts';
import DateTime from '_class/DateTime';
import api from 'lib/api';
import Modal from 'containers/Modals/Modal';
import UserAssessments from './UserAssessments';
import VerdictDisplay from 'containers/Verdict/Display/VerdictDisplay';
import VerdictWidget from 'containers/Verdict/Display/VerdictWidget';
import RowItem, { RowCell } from 'UI/Elements/List/RowItem';
import { Collapsible, ColorLabel, ColorLabelContainer, DataList, Skeleton, Spinner, Person } from 'UI';
import { Icon, TooltipMenu, Checkbox, Button, translate } from '@haldor/ui';
import './_mentorVerdicts.scss';

var MentorVerdicts = /*#__PURE__*/function (_Component) {
  _inherits(MentorVerdicts, _Component);

  var _super = _createSuper(MentorVerdicts);

  /* Class setup */
  function MentorVerdicts(props) {
    var _this;

    _classCallCheck(this, MentorVerdicts);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "componentDidMount", function () {
      _this.setState({
        loading: true
      });

      var promises = [];

      if (_this.props.verdictScale == null) {
        promises.push(_this.props.getVerdictScale());
      }

      var start = moment(moment(_this.props.start).startOf('day'), 'YYYY-MM-DD HH:mm:ss').utc().format();
      var end = moment(moment(_this.props.end).endOf('day'), 'YYYY-MM-DD HH:mm:ss').utc().format();
      promises.push(_this.props.getStudentVerdicts(_this.props.userId, start, end));
      Promise.all(promises).then(function () {
        _this.props.userCourses.forEach(function (course) {
          if (course.verdicts == null) {
            return false;
          }
        });

        _this.setState({
          loading: false,
          start: _this.props.start,
          end: _this.props.end
        });
      });
    });

    _defineProperty(_assertThisInitialized(_this), "componentDidUpdate", function () {
      if (_this.props.start != _this.state.start || _this.props.end != _this.state.end) {
        _this.setState({
          loading: true,
          start: _this.props.start,
          end: _this.props.end
        });

        _this.props.getStudentVerdicts(_this.props.userId, _this.props.start, _this.props.end).then(function () {
          _this.props.userCourses.forEach(function (course) {
            if (course.verdicts == null) {
              return false;
            }
          });

          _this.setState({
            loading: false
          });
        });
      }
    });

    _defineProperty(_assertThisInitialized(_this), "componentWillUnmount", function () {
      _this.props.clearVerdicts();
    });

    _defineProperty(_assertThisInitialized(_this), "toggleVerdictModal", function () {
      _this.setState({
        verdictModal: !_this.state.verdictModal
      });
    });

    _defineProperty(_assertThisInitialized(_this), "toggleOpen", function (course, active) {
      var open = _this.state.open;

      var found = _this.state.open.indexOf(course.id);

      if (active && found == -1) {
        open.push(course.id);
      }

      if (!active && found > -1) {
        open.splice(found, 1);
      }

      _this.setState({
        open: open
      });
    });

    _defineProperty(_assertThisInitialized(_this), "toggleOpenAll", function () {
      if (_this.state.open.length > 0) {
        _this.setState({
          open: []
        });
      } else {
        var group = _this.props.group;

        _this.setState({
          open: _toConsumableArray(_this.props.userCourses).map(function (course) {
            return course.id;
          })
        });
      }
    });

    _defineProperty(_assertThisInitialized(_this), "onCourseClick", function (course) {
      _this.setState({
        verdictLoading: true,
        course: course
      });

      var promises = [];

      _this.props.resetAssignmentAssessments();

      _this.props.resetPlanAssessments();

      promises.push(_this.props.getPlanAssessments(_this.props.userId, course.id));
      promises.push(_this.props.getVerdictsForUser(_this.props.userId, course.id, _this.props.start, _this.props.end));
      promises.push(_this.props.getAssignmentAssessments(_this.props.userId, course.id));
      Promise.all(promises).then(function () {
        _this.setState({
          verdictLoading: false
        });
      });

      _this.toggleVerdictModal();
    });

    _defineProperty(_assertThisInitialized(_this), "onRequestVerdict", function (course) {
      var translate = _this.props.translate;
      api.post("verdict/notify?studentId=".concat(_this.props.userId, "&courseId=").concat(course.id), {}).then(function (response) {
        _this.props.addError(translate('request-verdict-sucess'), 'info');
      })["catch"](function (error) {
        var message = translate('something-went-wrong');

        if (error.response.data != null && error.response.data.errorCode == 'H-003') {
          message = translate('request-verdict-teacher-error');
        }

        _this.props.addError(message, 'error');
      });
    });

    _defineProperty(_assertThisInitialized(_this), "requestVerdictForSelectedCourses", function () {
      _this.state.selectedCourses.forEach(function (course) {
        _this.onRequestVerdict(course);
      });
    });

    _defineProperty(_assertThisInitialized(_this), "toggleAllCourses", function (checked, courses) {
      if (checked) {
        _this.setState({
          selectedCourses: courses
        });
      } else {
        _this.setState({
          selectedCourses: []
        });
      }
    });

    _defineProperty(_assertThisInitialized(_this), "onCourseSelect", function (checked, course) {
      var selectedCourses = _this.state.selectedCourses;

      if (checked) {
        selectedCourses.push(course);
      } else {
        var found = selectedCourses.findIndex(function (selectedCourse) {
          return selectedCourse.id == course.id;
        });

        if (found > -1) {
          selectedCourses.splice(found, 1);
        }
      }

      _this.setState({
        selectedCourses: selectedCourses
      });
    });

    _defineProperty(_assertThisInitialized(_this), "onVerdictSubmit", function (verdict, course) {
      var promises = [];
      promises.push(_this.props.getVerdictsForUser(_this.props.userId, course.id, _this.props.start, _this.props.end));
      promises.push(_this.props.getStudentVerdicts(_this.props.userId, _this.props.start, _this.props.end));
      Promise.all(promises).then(function () {
        _this.setVerdictModalLoading(false);
      });
    });

    _defineProperty(_assertThisInitialized(_this), "setVerdictModalLoading", function (loading) {
      _this.setState({
        verdictModalLoading: loading
      });
    });

    _defineProperty(_assertThisInitialized(_this), "renderVerdict", function (verdict, index) {
      if (verdict == null) {
        return null;
      }

      var date = _this.props.tenant.currentSchoolYear != null ? _this.props.tenant.currentSchoolYear : '2017-01-01';
      var start = new DateTime(date).getDateStamp();
      var end = new DateTime(verdict.published).getDateStamp();
      var verdictBefore = _this.props.userVerdicts[index + 1];

      if (verdictBefore != null) {
        start = new DateTime(verdictBefore.published).getDateStamp();
      }

      var trigger = /*#__PURE__*/React.createElement("div", {
        style: {
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center'
        }
      }, /*#__PURE__*/React.createElement("div", {
        style: {
          flexGrow: 1
        }
      }, new DateTime(verdict.published).getLongDateWithTime()), /*#__PURE__*/React.createElement("div", {
        style: {
          flexGrow: 0
        }
      }, /*#__PURE__*/React.createElement(VerdictWidget, {
        verdict: verdict
      })));
      return /*#__PURE__*/React.createElement("div", {
        className: "verdict verdict-entry form-row",
        key: verdict.id
      }, /*#__PURE__*/React.createElement(Collapsible, {
        trigger: trigger
      }, /*#__PURE__*/React.createElement(VerdictDisplay, {
        verdict: verdict,
        course: _this.state.course,
        isStudent: _this.props.isStudent,
        reload: function reload() {
          return _this.onVerdictSubmit(verdict, _this.state.course);
        },
        setLoading: _this.setVerdictModalLoading
      })));
    });

    _defineProperty(_assertThisInitialized(_this), "renderCurrentVerdict", function (verdict) {
      if (verdict == null) {
        return null;
      }

      return /*#__PURE__*/React.createElement("div", {
        className: "verdict verdict-entry form-row"
      }, /*#__PURE__*/React.createElement("div", {
        style: {
          marginBottom: '1rem'
        }
      }, /*#__PURE__*/React.createElement("h3", null, _this.props.translate('current-verdict'))), /*#__PURE__*/React.createElement(VerdictDisplay, {
        verdict: verdict,
        isStudent: _this.props.isStudent,
        course: _this.state.course,
        reload: function reload() {
          return _this.onVerdictSubmit(verdict, _this.state.course);
        },
        setLoading: _this.setVerdictModalLoading
      }));
    });

    _defineProperty(_assertThisInitialized(_this), "renderVerdictsModal", function () {
      var currentVerdict = null;
      var verdicts = null;

      if (_this.props.userVerdicts != null && _this.props.userVerdicts.length > 0) {
        var publishedVerdicts = _this.props.userVerdicts.filter(function (v) {
          return v.status == "VERDICT_PUBLISHED";
        });

        currentVerdict = publishedVerdicts[0];
        verdicts = _toConsumableArray(publishedVerdicts);
        verdicts.splice(0, 1);
      }

      return /*#__PURE__*/React.createElement("div", null, currentVerdict != null && !_this.state.verdictLoading ? _this.renderCurrentVerdict(currentVerdict) : null, /*#__PURE__*/React.createElement("div", {
        className: "form-row",
        style: {
          marginBottom: '1rem'
        }
      }, /*#__PURE__*/React.createElement("h3", null, _this.props.translate('past-verdicts'))), _this.state.verdictLoading ? /*#__PURE__*/React.createElement(Spinner, {
        center: true
      }) : verdicts != null && verdicts.length != 0 ? verdicts.map(_this.renderVerdict) : /*#__PURE__*/React.createElement("div", {
        style: {
          textAlign: 'center',
          marginBottom: '2rem'
        }
      }, _this.props.translate('no-previous-verdicts')));
    });

    _defineProperty(_assertThisInitialized(_this), "renderPublishedInformation", function (verdict) {
      if (new Date(verdict.published) < new Date(verdict.edited)) {
        return /*#__PURE__*/React.createElement("div", {
          className: "info-draft"
        }, /*#__PURE__*/React.createElement("span", {
          className: "draft-badge",
          style: {}
        }, _this.props.translate('published') + ": " + new DateTime(verdict.published).getTimeStamp()), /*#__PURE__*/React.createElement("span", {
          className: "draft-badge",
          style: {
            marginLeft: '5px'
          }
        }, _this.props.translate('edited') + ": " + new DateTime(verdict.edited).getTimeStamp()));
      } else {
        return /*#__PURE__*/React.createElement("div", {
          className: "info-draft"
        }, /*#__PURE__*/React.createElement("span", {
          className: "draft-badge",
          style: {}
        }, _this.props.translate('published') + ": " + new DateTime(verdict.published).getTimeStamp()));
      }
    });

    _defineProperty(_assertThisInitialized(_this), "renderCourseRow", function (course) {
      var triggerButton = /*#__PURE__*/React.createElement(Button, {
        type: "secondary",
        style: {
          marginLeft: 0
        }
      }, "⋯");

      var found = _this.state.selectedCourses.findIndex(function (selectedCourse) {
        return selectedCourse.id == course.id;
      });

      var open = false;

      if (_this.state.open.indexOf(course.id) > -1) {
        open = true;
      }

      var verdict = course.verdicts.find(function (verdict) {
        return verdict.courses.find(function (co) {
          return co.courseID == course.id;
        });
      });
      var verdictValid = false;
      var feedback = '';
      if (verdict == null) return null;
      var verdictPublished = moment.utc(verdict.published).local();

      if (verdictPublished.isBetween(moment(_this.state.start).startOf('day'), moment(_this.state.end).endOf('day'))) {
        verdictValid = true;
      }

      if (verdict.feedback != null) {
        feedback = verdict.feedback.replace(/(\r\n|\r|\n)/g, '<br />');
      }

      var collapsibleTrigger = /*#__PURE__*/React.createElement("div", {
        style: {
          display: 'flex'
        }
      }, /*#__PURE__*/React.createElement(ColorLabelContainer, {
        style: {
          flex: 1
        }
      }, /*#__PURE__*/React.createElement(ColorLabel, {
        content: course.title + " " + (course.year != null ? course.year : ''),
        color: course.colorCode
      })), verdict != null && verdictValid ? /*#__PURE__*/React.createElement(VerdictWidget, {
        verdict: verdict
      }) : course.loading ? /*#__PURE__*/React.createElement(Skeleton, null) : null, verdict != null && verdictValid ? /*#__PURE__*/React.createElement("span", {
        style: {
          marginLeft: '.45rem'
        }
      }, new DateTime(verdict.published).getLongDate()) : null);
      return /*#__PURE__*/React.createElement(RowItem, {
        className: "row",
        key: course.id
      }, /*#__PURE__*/React.createElement(RowCell, {
        shrink: true,
        title: " "
      }, /*#__PURE__*/React.createElement("div", {
        className: "no-print"
      }, !_this.props.isStudent ? /*#__PURE__*/React.createElement(Checkbox, {
        value: found > -1,
        onChange: function onChange(c) {
          return _this.onCourseSelect(c, course);
        }
      }) : null)), /*#__PURE__*/React.createElement(RowCell, {
        title: "  "
      }, /*#__PURE__*/React.createElement(Collapsible, {
        open: open,
        onChange: function onChange(open) {
          return _this.toggleOpen(course, open);
        },
        trigger: collapsibleTrigger
      }, verdict != null ? /*#__PURE__*/React.createElement("div", {
        className: "verdict-feedback-row".concat(!open ? ' no-print' : '')
      }, verdict.createdBy != null ? /*#__PURE__*/React.createElement(Person, {
        style: {
          display: 'inline-flex'
        },
        person: verdict.createdBy
      }, /*#__PURE__*/React.createElement("span", {
        dangerouslySetInnerHTML: {
          __html: feedback
        }
      })) : /*#__PURE__*/React.createElement("span", {
        dangerouslySetInnerHTML: {
          __html: feedback
        }
      }), /*#__PURE__*/React.createElement(VerdictWidget, {
        verdict: verdict
      })) : null)), /*#__PURE__*/React.createElement(RowCell, {
        shrink: true,
        title: "   "
      }, /*#__PURE__*/React.createElement(Button, {
        type: "secondary",
        onClick: function onClick() {
          return _this.onCourseClick(course);
        }
      }, _this.props.translate('show-verdicts'))), !_this.props.isStudent ? /*#__PURE__*/React.createElement(RowCell, {
        shrink: true,
        title: "    "
      }, /*#__PURE__*/React.createElement(TooltipMenu, {
        trigger: triggerButton,
        id: course.id
      }, /*#__PURE__*/React.createElement(TooltipMenu.Item, {
        onClick: function onClick() {
          return _this.onCourseClick(course);
        }
      }, _this.props.translate('show-verdicts')), !_this.props.isStudent ? /*#__PURE__*/React.createElement(TooltipMenu.Item, {
        onClick: function onClick() {
          return _this.onRequestVerdict(course);
        }
      }, _this.props.translate('request-verdict')) : null)) : null);
    });

    _this.state = {
      verdictModal: false,
      verdictModalLoading: false,
      verdictLoading: false,
      loading: false,
      selectedCourses: [],
      course: null,
      open: [],
      start: _this.props.start,
      end: _this.props.end
    };
    return _this;
  }
  /* Lifecycle methods */


  _createClass(MentorVerdicts, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      if (this.state.loading) return /*#__PURE__*/React.createElement(Spinner, {
        center: true
      });
      var _this$state = this.state,
          selectedCourses = _this$state.selectedCourses,
          verdictModalLoading = _this$state.verdictModalLoading;
      var modalTitle = this.props.translate('verdicts');

      if (this.props.user != null) {
        modalTitle = this.props.translate('Verdicts for') + ' ' + this.props.user.firstName + ' ' + this.props.user.lastName;
      }

      var open = this.state.open.length > 0;
      return /*#__PURE__*/React.createElement("div", {
        className: "mentor-verdicts"
      }, /*#__PURE__*/React.createElement(Modal, {
        isOpen: this.state.verdictModal,
        onClose: this.toggleVerdictModal,
        title: modalTitle
      }, verdictModalLoading ? /*#__PURE__*/React.createElement(Spinner, {
        center: true
      }) : this.renderVerdictsModal()), /*#__PURE__*/React.createElement(DataList, {
        data: this.props.userCourses,
        renderRow: this.renderCourseRow,
        toggleAllEntries: !this.props.isStudent ? function (c) {
          return _this2.toggleAllCourses(c, _this2.props.userCourses);
        } : null,
        actions: !this.props.isStudent ? function () {
          return /*#__PURE__*/React.createElement("div", {
            className: "df aic jcb"
          }, /*#__PURE__*/React.createElement("div", {
            onClick: _this2.toggleOpenAll,
            className: open ? "color--meta toggle-all flip" : "color--meta toggle-all"
          }, /*#__PURE__*/React.createElement(Icon, {
            name: "ArrowLeft"
          }), open ? _this2.props.translate('Close all') : _this2.props.translate('Show all')), /*#__PURE__*/React.createElement("div", {
            style: {
              display: 'flex',
              alignItems: 'center'
            }
          }, /*#__PURE__*/React.createElement("div", {
            className: "no-print",
            style: {
              marginRight: '0.75rem'
            }
          }, /*#__PURE__*/React.createElement("div", {
            onClick: function onClick() {
              return window.print();
            },
            style: {
              cursor: 'pointer'
            },
            className: "color--meta"
          }, /*#__PURE__*/React.createElement("span", {
            style: {
              marginRight: '0.25rem',
              position: 'relative',
              top: 2
            }
          }, /*#__PURE__*/React.createElement(Icon, {
            name: "Printer"
          })), _this2.props.translate("print"))), /*#__PURE__*/React.createElement(Button, {
            type: "primary",
            onClick: _this2.requestVerdictForSelectedCourses,
            disabled: selectedCourses.length == 0
          }, _this2.props.translate('request-verdict'))));
        } : null
      }));
    }
  }]);

  return MentorVerdicts;
}(Component);

function mapStateToProps(state) {
  return {
    translate: translate(state.Languages.translations),
    userVerdicts: state.Verdicts.user,
    userCourses: state.user.userCourses,
    lastVerdicts: state.Verdicts.lastVerdicts,
    verdictScale: state.Verdicts.scale,
    tenant: state.user.tenant
  };
}

export default connect(mapStateToProps, {
  getVerdictsForUser: getVerdictsForUser,
  getUserCourses: getUserCourses,
  getStudentLatestVerdict: getStudentLatestVerdict,
  getStudentVerdicts: getStudentVerdicts,
  clearVerdicts: clearVerdicts,
  resetPlanAssessments: resetPlanAssessments,
  addError: addError,
  resetAssignmentAssessments: resetAssignmentAssessments,
  getPlanAssessments: getPlanAssessments,
  getAssignmentAssessments: getAssignmentAssessments,
  getVerdictScale: getVerdictScale
})(MentorVerdicts);